import PropTypes from "prop-types";

export const OrcaPropTypes = {
  /** Video UUID */
  uuid: PropTypes.string,
  /** When set, the player uses this value for videostart_id instead of generating its own */
  videoStartId: PropTypes.string,
  /** Video API Object */
  video: PropTypes.object,
  /** Pass callback function when video ends. */
  onVideoEnded: PropTypes.func,
  /** Pass callback function when video renders. */
  onVideoRendered: PropTypes.func,
  // TO DO: audit config props
  /** Pass in config to control size of player, showControls etc. */
  config: PropTypes.shape({
    /** Aspect ratio float, e.g. 0.5625 for 16:9
     * NOTE: Takes precedence over `aspectWidth` & `aspectHeight` */
    aspectRatio: PropTypes.number,
    /** Aspect ratio width, e.g. 16 for 16:9 */
    aspectWidth: PropTypes.number,
    /** Aspect ratio height, e.g. 9 for 16:9 */
    aspectHeight: PropTypes.number,
    /** Placeholder object */
    placeholder: PropTypes.object,
    /** React prop for class */
    className: PropTypes.string,
    /** Video caption */
    caption: PropTypes.node,
    /** Video a/b test group */
    testGroup: PropTypes.string,
    /** Video a/b test object */
    abTest: PropTypes.object,
    /** If video should load first video fragment on load. */
    loadFirstFragmentOnly: PropTypes.bool,
    /** HTML video preload attribute; defaults to "metadata" */
    preload: PropTypes.oneOf(["none", "metadata", "auto"]),
    /** Boolean value which enables/disables console log messages. */
    debug: PropTypes.bool,
    /** url that overrides promo image url */
    alternateArt: PropTypes.string,
    /** Boolean value to indicate if this player should playthrough to recommended videos (if video ANS additional_properties.embedContinuousPlay is also true); true by default */
    allowPlaythrough: PropTypes.bool,
    /** Boolean value to determine whether video will open in the sticky player when a user scrolls past it; true by default */
    isSticky: PropTypes.bool,
    /** Boolean value to indicates whether the player will allow ads (the video ANS also has fields that determine if ads are allowed for that particular video) */
    hasAds: PropTypes.bool,
    /** Boolean value determines if players surfaces logs from Zeus Iris, our ads plugin */
    debugZeus: PropTypes.bool,
    /** Boolean to set debug: true for HLSjs, useful for debugging auto-bitrate issues */
    debugHLS: PropTypes.bool,
    /** Optional `(eventAction, context) => boolean`. Return `false` to skip sending this event to the data layer (and skip `video-start` custom DOM side effects). Any other return value allows the event. */
    shouldSendAnalyticsEvent: PropTypes.func,
    /** Optional `(autoplayState, label, carouselState) => startReason` to replace default start-reason prefix used for analytics labels. Import `getStartReason` from this package to delegate or fall back to default mapping. */
    getStartReasonOverride: PropTypes.func,
    /**
     * Optional `(baseUrl, isVertical, height?) => { src, srcSet, sizes }` to replace
     * default responsive promo/wrapper image props. Import `buildPromoImageProps` from
     * this package to delegate or fall back to the default mapping.
     */
    buildPromoImagePropsOverride: PropTypes.func,
    /** Object value to allow users to override ad settings (mainly for testing and development) */
    adOverrides: PropTypes.shape({
      /** force orca player to allways render an ad */
      forceAd: PropTypes.bool,
      /** overrides the video ANS object's provided video adZone */
      adZoneOverride: PropTypes.string,
      /** overrides the provided timeout for ad calls */
      adTimeoutOverride: PropTypes.number,
      /** overrides the provided ad skip value (0 = no skip, 1 = skip) */
      skip: PropTypes.number,
      /** overrides the provided ad skip min value */
      skipmin: PropTypes.number,
      /** overrides the provided ad skip after value */
      skipafter: PropTypes.number,
      /** set whether add will preload in orca player */
      preloadAd: PropTypes.bool,
      /** mocks what domain the video is being rendered on */
      domain: PropTypes.string
    }),
    /** Embed dialog settings (domain, default iframe size, query params) */
    embed: PropTypes.shape({
      /** Hostname for embed iframe src */
      domain: PropTypes.string,
      /** Default iframe width shown in embed dialog (e.g. "100%") */
      defaultWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      /** Default iframe height shown in embed dialog (e.g. "352px") */
      defaultHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      /** Optional query string params appended to embed URL */
      queryParams: PropTypes.object,
      /**
       * Optional host override for embed iframe src.
       * Receives the same args as getEmbedUrl: { videoId, domain, queryParams }.
       */
      getEmbedUrlOverride: PropTypes.func
    })
  }),
  /** Boolan value to enable Promo video; true by default */
  promoEnabled: PropTypes.bool,
  /** Flag for lower environments */
  isSandbox: PropTypes.bool,
  /** Whether share button is displayed */
  allowShare: PropTypes.bool,
  /** Whether embed button is displayed (large screens only) */
  allowEmbed: PropTypes.bool,
  /** Override for whether video autoplays */
  isAutoplayOverride: PropTypes.bool,
  /** Override for whether video initializes muted */
  isMutedOverride: PropTypes.bool,
  /** Override for whether video initializes showing subtitles */
  showSubtitlesOverride: PropTypes.bool,
  /** Override for playerType in analytics */
  playerTypeOverride: PropTypes.string,
  stickyPlayerContext: PropTypes.object,
  orcaDeps: PropTypes.object
};
